import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';

const WATER_DROPS_SCRIPT_SRC = '/js/water-drops.js';
const WATER_DROPS_SCRIPT_ATTR = 'data-edteu-water-drops';

const CanvasWaterDropsLoader = (): null => {
  const scriptRef = useRef<HTMLScriptElement | null>(null);

  useEffect(() => {
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const scriptSelector = `script[${WATER_DROPS_SCRIPT_ATTR}]`;

    const skip = motionQuery.matches || document.querySelector(scriptSelector) !== null;

    let cleanup: (() => void) | undefined;

    if (!skip) {
      window.gsap = gsap;

      const rafId = requestAnimationFrame(() => {
        if (document.querySelector(scriptSelector)) {
          return;
        }
        const script = document.createElement('script');
        script.src = WATER_DROPS_SCRIPT_SRC;
        script.async = true;
        script.setAttribute(WATER_DROPS_SCRIPT_ATTR, 'true');
        document.body.appendChild(script);
        scriptRef.current = script;
      });

      cleanup = () => {
        cancelAnimationFrame(rafId);
        const { current } = scriptRef;
        if (current?.isConnected) {
          current.remove();
        }
        scriptRef.current = null;
      };
    }

    return cleanup;
  }, []);

  return null;
};

export default CanvasWaterDropsLoader;
